import { useEffect } from 'react';
import { ICustomProperties } from '@microsoft/applicationinsights-web';
import { LoginUser } from 'types/model/user';
import { appInsights } from '../azure-application-insights';
import { useUserReadFacade } from '../redux/user-read/user-read.facade';

/**
 * 指定されたユーザ情報からApplicationInsightsに送信する属性を選択する
 * @param user ユーザ情報
 * @param value ユーザ属性を付与したいICustomPropertiesオブジェクト
 */
export const getUserProperties = (user: LoginUser, value? : ICustomProperties): ICustomProperties => {
// 必要な属性のみに限定する
  const user_attr_keys: Array<keyof LoginUser> = [
    'aap',
    'company_chief_type',
    'company_name',
    'company_register_type',
    'family_name',
    'given_name',
    'locale',
    'name',
    'user_register_type',
    'xgrab_company_id',
    'xgrab_user_id',
    'zoneinfo',
  ];
  const properties = value || {};
  const reducer = (pre: ICustomProperties, key: keyof LoginUser) => {
    pre[key] = user[key];
    return pre;
  };
  return user_attr_keys.reduce(reducer, properties);
};

export const useAppInsightsUserAttributes = () => {
  const { user, loggedIn } = useUserReadFacade();

  useEffect(() => {
    if (user && loggedIn && appInsights.appInsights.isInitialized()) {
      appInsights.addTelemetryInitializer((item) => {
        item.data = getUserProperties(user, item.data);
      });
    }
  }, [user, loggedIn]);
};
